import styled, {css} from 'styled-components'

export default styled.video`
  // min-width: 100%;
  min-height: 100%;
  object-fit: cover;

  ${props => props.experiment && css`
      filter: blur(50px) contrast(5);
  `}

  z-index: -1;

  &:hover {
    filter: blur(5px);
  }
`



// WEBPACK FOOTER //
// ./src/components/Video.js